<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 223 223">
  <g transform="translate(-849 -429)">
    <g transform="translate(0 53)">
      <circle cx="111.5" cy="111.5" r="111.5" transform="translate(849 376)" fill="#e73939" />
    </g>
    <g transform="translate(897 483.999)">
      <path fill="#fff" d="M7.869,125.443c-.025.05-.05.075-.075.125a15.238,15.238,0,0,0,13.45,22.408h94.925a15.25,15.25,0,0,0,13.45-22.433c-.025-.05-.05-.075-.075-.125L81.767,46.552a15.255,15.255,0,0,0-26.1,0ZM60.262,49.337a9.9,9.9,0,0,1,16.912-.025v.025l.025.025,47.726,78.766.025.05.025.05a9.875,9.875,0,0,1-8.757,14.428H21.268a9.875,9.875,0,0,1-8.757-14.428l.025-.05.025-.05Z" transform="translate(-5.982 -39.2)"/>
      <path fill="#fff" d="M245.738,148a3.443,3.443,0,0,0-3.438,3.438v41.88a3.438,3.438,0,0,0,6.875,0v-41.88A3.427,3.427,0,0,0,245.738,148Z" transform="translate(-183.002 -120.699)"/>
      <path fill="#fff" d="M245.738,366.7a3.425,3.425,0,1,0,3.438,3.413A3.406,3.406,0,0,0,245.738,366.7Z" transform="translate(-183.002 -284.522)"/>
    </g>
  </g>
</svg>
